import { ICongelamentoEmLote } from "../../../../pages/CongelamentoCNPJ/Congelamentos/AbaCongelamentoEmLote/interface";
import { IReqCongelamentoUnico, IReqItensCongelamentoUnicoModal } from "../../../../pages/CongelamentoCNPJ/Congelamentos/AbaCongelamentoUnicoCNPJ/interface";
import { api } from "../../../apiAxios";
import { getToken } from "../../../LStorage/token";
import { urlHttpGov } from "../../../urls";

class CongelamentoEmLoteService {
    private readonly baseURL = `${urlHttpGov}/congelamento-cnpj/em-lote`;

    async getCongelamentos(signal?: AbortSignal): Promise<Array<ICongelamentoEmLote>> {

        const { data } = await api.get(`${this.baseURL}/solicitacao`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            signal
        });

        return data;
    }

    async getCongelamentosArquivo(filename: string, signal?: AbortSignal): Promise<{ signedUrl: string }> {

        const { data } = await api.get(`${this.baseURL}/solicitacao/arquivo/${filename}/link`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            signal
        });

        return data;
    }

    async postCongelamentoEmLote(
        formData: FormData,
        signal?: AbortSignal
    ) {

        const { data } = await api.post(`${this.baseURL}`,
            formData,
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken(),
                    "Content-Type": "multipart/form-data",
                },
                signal
            });

        return data
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new CongelamentoEmLoteService();
